import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdmin } from "./AdminContext";

export function Protected({ children, role }) {
  const { user } = useAdmin();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-charcoal" data-testid="admin-loading">
        <Loader2 className="h-8 w-8 animate-spin text-ivory/60" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (role && user.role !== role) return <Navigate to="/admin" replace />;
  return children;
}
